import { render, staticRenderFns } from "./enderecoEntregaEdit.vue?vue&type=template&id=4b0ec858"
import script from "./enderecoEntregaEdit.ts?vue&type=script&lang=js&external"
export * from "./enderecoEntregaEdit.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0ec858')) {
      api.createRecord('4b0ec858', component.options)
    } else {
      api.reload('4b0ec858', component.options)
    }
    module.hot.accept("./enderecoEntregaEdit.vue?vue&type=template&id=4b0ec858", function () {
      api.rerender('4b0ec858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/cliente/enderecoEntregaEdit.vue"
export default component.exports